import React, { Component }from 'react'
import { Field, reduxForm } from 'redux-form'
import { Link } from 'react-router'
import CSSModules from 'react-css-modules'
import styles from './profileConfirme.css'
import InputProfile from '../components/componentKit2/InputProfile'
import { api, host, domen } from '../config.js'
import { SubmissionError } from 'redux-form'
import Modal from 'boron/FadeModal'
import LogoLink from '../components/componentKit/LogoLink'

let contentStyle = {
  borderRadius: '18px',
  padding: '30px'
}

let failMessage = 'Пользователь с таким email, не найден'

const defaultBg = <img className={styles.alfaBg} src="/assets/img/els/els-bg2.jpg" alt=""/>

class ProfileConfirme extends  Component {
  onSubmit(data){
    this.refs.loadingModal.show()
    data.url = `${host}/confirme`
    return fetch(`${api}/user/user-sendconfirmEmail`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(json => {

        this.refs.loadingModal.hide()
        if (json.data) {
          if (json.data.resultCode === 1) {
            this.refs.successModal.show()
          } else {
            failMessage = json.data.resultText
            this.refs.failModal.show()
          }
        } else {
          throw new SubmissionError({
            password: '',
            _error: 'Что-то пошло не так, попробуйте снова'
          })
        }
      })
  }

  render() {
    const {error, handleSubmit} = this.props
    const  isAlfa = domen.isAlfa
    const  isTele2Lk = domen.isTele2
    const isUnipro = domen.isUnipro
    let bg = defaultBg

    return (
      <div className={styles.layoutEntry}>
        <div className={styles.gridEntryHeader}>
          <div className={styles.gridCellTodaymeLogo}>
            <LogoLink isUnipro={isUnipro} isAlfa={isAlfa}/>
          </div>
        </div>

        <div className={styles.entryMin}>
          <div className={styles.entryInner}>

            <div className={styles.entryHeader}>
              <h2 className={isAlfa ? styles.entryTitleCenterAlfa : styles.entryTitleCenter}>Подтверждение почты</h2>
            </div>

            <form onSubmit={handleSubmit(this.onSubmit.bind(this))} className={styles.entryBox}>

              <Field name='email' id='login[1]' placeholder='Ваш email' component={InputProfile}/>

              {error && <strong className={styles.error}>{error}</strong>}

              <button type='submit' className={styles.btnSecondaryWideMb20}>
                Получить письмо
              </button>

              <Modal ref='successModal' contentStyle={contentStyle}>
                <h2>Письмо с инструкциями отправлено на указанный вами email</h2>
                <div className={styles.btnPrimary} onClick={() => {
                  this.refs.successModal.hide()
                }}>
                  Продолжить
                </div>
              </Modal>

              <Modal ref='failModal' contentStyle={contentStyle}>
                <h2>{failMessage}</h2>
                <div className={styles.btnPrimary} onClick={() => {
                  this.refs.failModal.hide()
                }}>
                  Продолжить
                </div>
              </Modal>

              <Modal ref='loadingModal' contentStyle={contentStyle}>
                <div className={styles.entryHeader}>
                  <h2 className={styles.entryTitleCenter}>Загружается...</h2>
                </div>
                <div className={styles.textCenter}>
                  <div className={styles.loaderMain}></div>
                </div>
              </Modal>

              <ul className={styles.entryNav}>
                <li className={styles.entryNavItem}>
                  <Link to="/">Вход в кабинет</Link>
                </li>
              </ul>
            </form>
          </div>
          <div className={styles.entryBg}>
            {bg}
          </div>
        </div>

      </div>

    )
  }
}

const validate = data => {
  const errors = {}

  if (data.email) {
    data.email = data.email.replace(/ /g, '')
  }

  switch (true) {
    case !data.email:
      errors.email = 'Email должен быть заполнен'
      break
    case !/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(data.email):
      errors.email = 'Email заполнен неправильно, проверьте его еще раз'
      break
    default:
      break
  }

  return errors
}

export default CSSModules(reduxForm({
  form: 'signupValidation',
  validate
})(ProfileConfirme), styles)



// WEBPACK FOOTER //
// /var/www/build-health-2/src/containers/ProfileConfirme.js